











































import { typeIsCreditCard } from '@spa/store/modules/orderConfirm/types'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'

@Component
export default class Creditcard extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  numberLast4: string

  @Prop({ required: true })
  use: () => Promise<void>

  @Prop({ required: true })
  remove: () => Promise<void>

  @Prop({ required: true })
  paymentType: string | undefined

  @Prop({ required: true })
  selectedId: string | undefined

  get isSelected(): boolean {
    return this.paymentType !== undefined
      && typeIsCreditCard(this.paymentType)
      && this.id === this.selectedId
  }
}
